/** Same-origin API base (CRA proxy / static host). */
export const API = '';

const TOKEN_KEY = 'dash_auth_token';

export function getToken(): string | null {
  try {
    return sessionStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string) {
  try {
    sessionStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* ignore */
  }
}

export function clearToken() {
  try {
    sessionStorage.removeItem(TOKEN_KEY);
  } catch {
    /* ignore */
  }
}

function mergeAuthHeaders(init?: RequestInit): Headers {
  const h = new Headers(init?.headers ?? undefined);
  const t = getToken();
  if (t && !h.has('Authorization')) h.set('Authorization', `Bearer ${t}`);
  return h;
}

/**
 * Authenticated fetch for `/api/*`. On 401, clears token and sends user to login.
 */
export async function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const headers = mergeAuthHeaders(init);
  const res = await fetch(input, { ...init, headers });
  if (res.status === 401) {
    clearToken();
    if (typeof window !== 'undefined') window.location.hash = '#/login';
  }
  return res;
}
